const DEV_SUPABASE_URL = "http://127.0.0.1:54321";
const DEV_SUPABASE_PUBLISHABLE_KEY = "sb_publishable_local_dev_placeholder";
const DEFAULT_MOBILE_APP_SCHEME = "match://app";

function cleanEnvValue(value: string | undefined) {
  const trimmed = value?.trim();
  return trimmed || undefined;
}

function isProductionBuild() {
  return import.meta.env.PROD || import.meta.env.MODE === "production";
}

function withDevelopmentFallback(value: string | undefined, fallback: string) {
  if (value) return value;
  return isProductionBuild() ? "" : fallback;
}

function extractSupabaseProjectId(supabaseUrl: string | undefined) {
  if (!supabaseUrl) return undefined;

  try {
    const hostname = new URL(supabaseUrl).hostname;
    const suffix = ".supabase.co";

    if (hostname.endsWith(suffix)) {
      return hostname.slice(0, -suffix.length);
    }
  } catch {
    return undefined;
  }

  return undefined;
}

const supabaseUrl = withDevelopmentFallback(
  cleanEnvValue(import.meta.env.VITE_SUPABASE_URL),
  DEV_SUPABASE_URL,
);
const supabasePublishableKey = withDevelopmentFallback(
  cleanEnvValue(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY),
  DEV_SUPABASE_PUBLISHABLE_KEY,
);
const supabaseProjectId =
  cleanEnvValue(import.meta.env.VITE_SUPABASE_PROJECT_ID) ??
  extractSupabaseProjectId(supabaseUrl) ??
  "";

const missingProductionKeys = isProductionBuild()
  ? [
      ["VITE_SUPABASE_URL", supabaseUrl],
      ["VITE_SUPABASE_PUBLISHABLE_KEY", supabasePublishableKey],
    ]
      .filter(([, value]) => !value)
      .map(([key]) => key)
  : [];

export const publicConfigStatus = {
  isValid: missingProductionKeys.length === 0,
  missingKeys: missingProductionKeys,
};

export const publicConfig = {
  supabaseUrl,
  supabasePublishableKey,
  supabaseProjectId,
  googleMapsApiKey: cleanEnvValue(import.meta.env.VITE_GOOGLE_MAPS_API_KEY),
  googleMapsMapId: cleanEnvValue(import.meta.env.VITE_GOOGLE_MAPS_MAP_ID) ?? "DEMO_MAP_ID",
  turnstileSiteKey: cleanEnvValue(import.meta.env.VITE_TURNSTILE_SITE_KEY),
  pushVapidPublicKey: cleanEnvValue(import.meta.env.VITE_PUSH_VAPID_PUBLIC_KEY),
  appUrl:
    cleanEnvValue(import.meta.env.VITE_PUBLIC_APP_URL) ??
    (typeof window !== "undefined" ? window.location.origin : "https://quadra-certa.pages.dev"),
  mobileAppScheme:
    cleanEnvValue(import.meta.env.VITE_MOBILE_APP_SCHEME) ??
    cleanEnvValue(import.meta.env.VITE_PUBLIC_APP_MOBILE_URL) ??
    DEFAULT_MOBILE_APP_SCHEME,
};
